import { render, staticRenderFns } from "./lecturePaysage.vue?vue&type=template&id=5e7b60f2&scoped=true&"
import script from "./lecturePaysage.vue?vue&type=script&lang=js&"
export * from "./lecturePaysage.vue?vue&type=script&lang=js&"
import style0 from "./lecturePaysage.vue?vue&type=style&index=0&id=5e7b60f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b60f2",
  null
  
)

export default component.exports